import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';

export const eslConfigRoutes: Routes = [
  {
    path: 'esl-config',
    loadComponent: () => import('./pages/esl-config/esl-config.component'),
    providers: [],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
  },
];
